<template lang="pug">
div
  div.has-text-weight-bold {{goal.title}}
  div(v-for="g in relevantGoals")
    .goals
      .goal(v-for="a in getAncestors(g.parent)" :style="{'background-color': a.color}") {{a.title}}
    div(:class="{'has-text-weight-bold': g.description}") {{g.title}}
    div(v-if="g.description") {{g.description}}
</template>

<script>
export default {
  props: ['row', 'goal'],
  computed: {
    relevantGoals () {
      const descendants = (g) => {
        return [g].concat(g.hasChildren ? _.flatten(_.map(g.children, descendants)) : [])
      }

      return _.filter(descendants(this.goal), (g) => (this.row.tags.indexOf(g.key) > -1) || (this.row.tags.indexOf(g.code) > -1))
    }
  },
  methods: {
    getAncestors (g) {
      if (!g) return []
      return g.parent ? this.getAncestors(g.parent).concat([g]) : []
    }
  }
}
</script>

<style scoped>
.goals {
  margin-top: 4px;
}
.goals::before {
  content: '\2022 ';
  margin-left: -12px;
}
.goal {
  display: inline-block;
  font-size: 12px;
  padding: 4px;
  border: 1px solid #666;
  border-radius: 4px;
  margin-right: 4px;
}
</style>
